import { render, staticRenderFns } from "./QuestionMultiChoiceDisplay.vue?vue&type=template&id=eeea4826&scoped=true&"
import script from "./QuestionMultiChoiceDisplay.vue?vue&type=script&lang=js&"
export * from "./QuestionMultiChoiceDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeea4826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Dan/code/teacher-helper/teacher-helper/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {VDivider,VRadio,VRadioGroup})
